import {textHandle} from 'presentation/utils/textHandle';

const matchesProviderName = (field: string | undefined | null, providerName: string): boolean => {
	const fieldFormatted = textHandle(field ?? '').sanitizeText();
	const providerNameFormatted = textHandle(providerName).sanitizeText();

	return fieldFormatted.includes(providerNameFormatted) || false;
};

export {matchesProviderName};
